export default "__VITE_ASSET__b3c472ec__"